import { ICellRendererParams } from 'ag-grid-community';
import React from 'react';


interface Props extends ICellRendererParams {
    EmptyLabel: string;
}

const NoRowsOverlay = (props: Props) => {
    return (
        <div className="d-flex">
            <span className={"mx-auto empty-label h5-regular"}>{props.EmptyLabel}</span>
        </div>
    )
}

export default NoRowsOverlay